import { Reveal } from "./Section";

const WIDE = "/video/crossjobs-ad-60s-wide";
const TALL = "/video/crossjobs-ad-30s-phone";
const V = "?v=invoices1";
const BASE = "rounded-2xl border border-white/10 shadow-2xl bg-black";

// Home band with the advert: widescreen on tablets and up, the upright cut on phones.
export const VideoDemo = () => (
  <section id="video" className="relative bg-[#0B1120] text-white py-20 sm:py-24 overflow-hidden home-noise scroll-mt-16" data-testid="home-video">
    <div className="absolute inset-0 home-grid opacity-60" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[0.75fr_1.6fr] gap-10 lg:gap-14 items-center">
      <Reveal>
        <p className="font-mono text-xs font-semibold tracking-[0.2em] uppercase text-[#EA580C]">Watch · The real app</p>
        <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]" data-testid="home-video-title">
          See Cross Jobs <span className="text-[#EA580C]">in action.</span>
        </h2>
        <p className="mt-5 text-base md:text-lg text-slate-400 leading-relaxed">
          The real app, start to finish: sending jobs, crew check-ins and photos, the client report and payroll. Filmed with our plastering, mowing and cleaning demo crews.
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <video className={`hidden sm:block w-full aspect-video ${BASE}`} controls preload="none" playsInline poster={`${WIDE}-poster.jpg${V}`} data-testid="home-video-wide">
          <source src={`${WIDE}.mp4${V}`} type="video/mp4" />
        </video>
        <video className={`sm:hidden mx-auto w-full max-w-[340px] aspect-[9/16] ${BASE}`} controls preload="none" playsInline poster={`${TALL}-poster.jpg${V}`} data-testid="home-video-tall">
          <source src={`${TALL}.mp4${V}`} type="video/mp4" />
        </video>
      </Reveal>
    </div>
  </section>
);
